// src/pages/admin/subcategories/index.tsx
import React, { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
// Removida a importação do DashboardLayout
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { PlusCircle } from 'lucide-react';
import { SubcategoriesList } from '@/components/admin/categories/SubcategoriesList';
import { SubcategoryDialog } from '@/components/admin/categories/SubcategoryDialog';
import type { Subcategory } from '@/types/category';

const AdminSubcategoriesPage: React.FC = () => {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [dialogMode, setDialogMode] = useState<'addSubcategory' | 'editSubcategory' | null>(null);
    const [itemToEdit, setItemToEdit] = useState<Subcategory | null>(null);
    const [refreshKey, setRefreshKey] = useState(0); // State to trigger list refresh

    // const queryClient = useQueryClient(); // Get query client if needed for invalidation

    const handleOpenDialog = (mode: 'addSubcategory' | 'editSubcategory', item?: Subcategory) => {
        setDialogMode(mode);
        setItemToEdit(item || null);
        setIsDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setIsDialogOpen(false);
        setDialogMode(null);
        setItemToEdit(null);
    };

    const handleSuccess = () => {
        handleCloseDialog();
        setRefreshKey(prev => prev + 1); // Increment key to refresh the list
        // Optionally invalidate queries if using react-query heavily elsewhere
        // queryClient.invalidateQueries(['subcategories']);
    };

    return (
        // Conteúdo da página diretamente, sem o DashboardLayout
        <> 
            <div className="flex items-center justify-between space-y-2 pb-4">
                <h2 className="text-3xl font-bold tracking-tight">Gerenciar Subcategorias</h2>
                <Button onClick={() => handleOpenDialog('addSubcategory')} size="sm">
                    <PlusCircle className="mr-2 h-4 w-4" /> Nova Subcategoria
                </Button>
            </div>
            <Card>
                <CardHeader>
                    <CardTitle>Lista de Subcategorias</CardTitle>
                    <CardDescription>
                        Visualize e gerencie as subcategorias dos produtos.
                    </CardDescription>
                </CardHeader>
                <CardContent>
                    <SubcategoriesList
                        onEditSubcategory={(sub) => handleOpenDialog('editSubcategory', sub)}
                        onAddSubcategory={() => handleOpenDialog('addSubcategory')}
                        refreshKey={refreshKey}
                    />
                </CardContent>
            </Card>

            <SubcategoryDialog
                isOpen={isDialogOpen}
                mode={dialogMode}
                itemToEdit={itemToEdit}
                onClose={handleCloseDialog}
                onSuccess={handleSuccess}
            />
        </>
    );
};

export default AdminSubcategoriesPage;
